import { useTheme } from "@mui/material"
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Tooltip, IconButton } from "@mui/material"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline"
import { InvoiceRow } from "."
import OutlinedInput from "src/shared/components/outlined-input"
import SelectInvoiceParticularField from "src/shared/container/select-invoice-particular-field"

// --- InvoiceTable Component ---
interface InvoiceTableProps {
  rows: InvoiceRow[]
  onRowChange: (idx: number, field: keyof InvoiceRow, value: string) => void
  onAddRow: (idx: number) => void
  onRemoveRow: (idx: number) => void
  total: number
  totalUnitPrice: number
  errors: boolean[]
}

const InvoiceTable: React.FC<InvoiceTableProps> = ({
  rows,
  onRowChange,
  onAddRow,
  onRemoveRow,
  total,
  totalUnitPrice,
  errors
}) => {
  const theme = useTheme()
  return (
    <TableContainer sx={{ borderRadius: 2, boxShadow: 1, background: "#fff" }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ background: theme.palette.grey[100] }}>
            <TableCell>
              <b>Items</b>
            </TableCell>
            <TableCell>
              <b>Unit Price</b>
            </TableCell>
            <TableCell>
              <b>Units</b>
            </TableCell>
            <TableCell>
              <b>Amount</b>
            </TableCell>
            <TableCell align="center">
              <b>Actions</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => {
            console.log("row", row)
            return (
              <TableRow
                key={idx}
                sx={{
                  background: idx % 2 === 0 ? theme.palette.grey[50] : "#fff",
                  "&:hover": { background: theme.palette.action.hover },
                  transition: "background 0.2s"
                }}
              >
                <TableCell sx={{ width: "30%" }}>
                  <SelectInvoiceParticularField
                    value={row.item?.value || ""}
                    onChange={(_, option) => onRowChange(idx, "item", option)}
                    fullWidth
                    error={errors[idx] && !row.item}
                    placeholder="Enter item"
                  />
                  {/* <OutlinedInput
                  value={row.item}
                  onChange={e => onRowChange(idx, "item", e.target.value)}
                  fullWidth
                  error={errors[idx] && !row.item}
                  placeholder="Enter item"
                  size="small"
                /> */}
                </TableCell>
                <TableCell>
                  <OutlinedInput
                    type="number"
                    className="numberinput"
                    value={row.unitPrice}
                    onChange={e => onRowChange(idx, "unitPrice", e.target.value)}
                    fullWidth
                    error={errors[idx] && !row.unitPrice}
                    placeholder="0"
                    size="small"
                    inputProps={{ min: 0 }}
                  />
                </TableCell>
                <TableCell>
                  <OutlinedInput
                    type="number"
                    className="numberinput"
                    value={row.units}
                    onChange={e => onRowChange(idx, "units", e.target.value)}
                    fullWidth
                    error={errors[idx] && !row.units}
                    placeholder="0"
                    size="small"
                    inputProps={{ min: 0 }}
                  />
                </TableCell>
                <TableCell>
                  <OutlinedInput value={row.amount} inputProps={{ readOnly: true }} fullWidth size="small" />
                </TableCell>
                <TableCell align="center">
                  <Tooltip title="Add row">
                    <span>
                      <IconButton onClick={() => onAddRow(idx)} color="primary" size="small">
                        <AddCircleOutlineIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Remove row">
                    <span>
                      <IconButton
                        onClick={() => onRemoveRow(idx)}
                        color="error"
                        size="small"
                        disabled={rows.length === 1}
                      >
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            )
          })}
          <TableRow>
            <TableCell align="center">
              <b>Total</b>
            </TableCell>
            <TableCell colSpan={2}>
              <b>{totalUnitPrice.toLocaleString()}</b>
            </TableCell>
            <TableCell colSpan={2}>
              <b>{total.toLocaleString()}</b>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default InvoiceTable
